// Utils.js

import u from "umbrellajs";
import { showDataModalCustom, showPasswordTokenPanel } from "../modal";

function detectIEEdge() {
  const ua = window.navigator.userAgent;

  const msie = ua.indexOf("MSIE ");
  if (msie > 0) {
    // IE 10 or older => return version number
    return parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)), 10);
  }

  const trident = ua.indexOf("Trident/");
  if (trident > 0) {
    // IE 11 => return version number
    const rv = ua.indexOf("rv:");
    return parseInt(ua.substring(rv + 3, ua.indexOf(".", rv)), 10);
  }

  const edge = ua.indexOf("Edge/");
  if (edge > 0) {
    // Edge => return version number
    return parseInt(ua.substring(edge + 5, ua.indexOf(".", edge)), 10);
  }

  // other browser
  return false;
}

function convertToArray(nodes) {
  const array = null;

  try {
    array = Array.prototype.slice.call(nodes, 0);
  } catch (ex) {
    array = new Array();
    for (const i = 0, len = nodes.length; i < len; i++) {
      array.push(nodes[i]);
    }
  }
  return array;
}

function lazyLoad(target) {
  const obs = new IntersectionObserver(function (entries, observer) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        const img = entry.target;
        const src = img.getAttribute("data-lazy");

        img.setAttribute("src", src);

        observer.disconnect();
      }
    });
  });
  obs.observe(target);
}

function lazyLoadIE(target) {
  const img = target;

  const src = img.getAttribute("data-lazy");

  img.setAttribute("src", src);
}

function createNotification(message) {
  const $toastViewArea = document.getElementById("toastViewArea");
  const $createNotification = document.createElement("div");

  $createNotification.classList.add("toast_view");

  $createNotification.innerHTML = message;

  $toastViewArea.appendChild($createNotification);

  setTimeout(() => {
    $createNotification.remove();
  }, 7000);
}

function createSwiper() {
  const slides = document.querySelectorAll(".swiper-slide");
  const container = document.querySelector(".swiper-container");
  const pagination = document.querySelector(".swiper-pagination");

  if (slides.length > 0) {
    let currentIndex = 0;
    let autoplayInterval;
    const autoplayDelay = 5000; // Delay en milisegundos (3 segundos en este ejemplo)

    // Función para crear bullets de paginación
    function createPaginationBullets() {
      slides.forEach((slide, i) => {
        const bullet = document.createElement("span");
        bullet.classList.add("swiper-pagination-bullet");
        if (i === 0) {
          bullet.classList.add("swiper-pagination-bullet-active");
        }
        bullet.addEventListener("click", () => {
          showSlide(i);
          stopAutoplay();
        });
        pagination.appendChild(bullet);
      });
    }

    createPaginationBullets();

    function showSlide(index) {
      slides.forEach((slide, i) => {
        if (i === index) {
          slide.classList.add("active");
        } else {
          slide.classList.remove("active");
        }
      });

      const bullets = document.querySelectorAll(".swiper-pagination-bullet");
      bullets.forEach((bullet, i) => {
        if (i === index) {
          bullet.classList.add("swiper-pagination-bullet-active");
        } else {
          bullet.classList.remove("swiper-pagination-bullet-active");
        }
      });

      currentIndex = index;
    }

    function goToNextSlide() {
      const nextIndex = (currentIndex + 1) % slides.length;
      showSlide(nextIndex);
    }

    function startAutoplay() {
      autoplayInterval = setInterval(goToNextSlide, autoplayDelay);
    }

    function stopAutoplay() {
      clearInterval(autoplayInterval);
    }

    startAutoplay();

    container.addEventListener("mouseenter", stopAutoplay);
    container.addEventListener("mouseleave", startAutoplay);

    showSlide(currentIndex);
  }
}

function createCarrusel() {
  const carousel = document.querySelector(".carousel");
  const carouselItems = document.querySelectorAll(".carousel-item");
  const pagination = document.querySelector(".pagination");
  const paginationDots = [];

  if (carousel) {
    let currentIndex = 0;
    let autoplayInterval;
    const autoplayDelay = 5000; // Delay en milisegundos (3 segundos en este ejemplo)

    function createPaginationDots() {
      carouselItems.forEach((item, index) => {
        const dot = document.createElement("span");
        dot.classList.add("pagination-dot");
        if (index === 0) {
          dot.classList.add("active");
        }
        dot.addEventListener("click", () => {
          showSlide(index);
          stopAutoplay();
        });
        pagination.appendChild(dot);
        paginationDots.push(dot);
      });
    }

    function showSlide(index) {
      carouselItems.forEach((item, i) => {
        if (i === index) {
          item.classList.add("active");
        } else {
          item.classList.remove("active");
        }
      });

      paginationDots.forEach((dot, i) => {
        if (i === index) {
          dot.classList.add("active");
        } else {
          dot.classList.remove("active");
        }
      });

      currentIndex = index;
    }

    function goToNextSlide() {
      const nextIndex = (currentIndex + 1) % carouselItems.length;
      showSlide(nextIndex);
    }

    function startAutoplay() {
      autoplayInterval = setInterval(goToNextSlide, autoplayDelay);
    }

    function stopAutoplay() {
      clearInterval(autoplayInterval);
    }

    createPaginationDots();
    startAutoplay();

    carousel.addEventListener("mouseenter", stopAutoplay);
    carousel.addEventListener("mouseleave", startAutoplay);

    showSlide(currentIndex);
  }
}

function toggleShowOrHidePass($input) {
  $input.attr("type") === "password"
    ? $input.attr("type", "text")
    : $input.attr("type", "password");
}

function validateEmail(email) {
  const regex =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return regex.test(String(email).toLowerCase());
}

function showPasswordRecovery() {
  u("#formRegister").removeClass("show").addClass("hidden");
  u("#formSignIn").removeClass("show").addClass("hidden");
  u("#formPasswordRecovery").removeClass("hidden").addClass("show");
}

function showSigIn() {
  u("#formRegister").removeClass("show").addClass("hidden");
  u("#formSignIn").removeClass("hidden").addClass("show");
  u("#formPasswordRecovery").removeClass("show").addClass("hidden");
}

function showRecoveryPasswordNotification() {
  const queryString = window.location.search;

  const searchParams = new URLSearchParams(queryString);

  const loginParam = searchParams.get("login");
  const messageParam = searchParams.get("message");

  if (loginParam === "REMEMBER") {
    createNotification(messageParam);
  }
}

function changePasswordPanel() {
  const queryString = window.location.search;

  const searchParams = new URLSearchParams(queryString);

  const loginParam = searchParams.get("login");
  const messageParam = searchParams.get("message");

  if (loginParam === "CHANGE_PASSWORD") {
    showPasswordTokenPanel();
  }
}

function loadMoreInformation() {
  fetch(`${MAIN_WEB_ROOT}ajax/app/custom/users/moreInformation`, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: "html",
  })
    .then((response) => response.text())
    .then((response) => {
      showDataModalCustom(response);
    });
}

function scrollUp() {
  const $scrollToUpButton = u(".scrollToUp");

  if ($scrollToUpButton.length > 0) {
    $scrollToUpButton.on("click", function (event) {
      event.preventDefault();

      const scrollDuration = 2000;
      const scrollStep = -window.scrollY / (scrollDuration / 15);

      const scrollInterval = setInterval(function () {
        if (window.scrollY !== 0) {
          window.scrollBy(0, scrollStep);
        } else {
          clearInterval(scrollInterval);
        }
      }, 15);
    });
  }
}

const oTrackingEvents = {
  sendFBEvents: false,
  sendGAEvents: false,
  _aCacheEventGA: [],
  _aCacheEventFB: [],
  sendEvent: function (category, action, label) {
    let eventGA = {
      event_category: category,
      event_action: action,
      event_label: label,
    };
    let eventFB = { category: category, action: action, label: label };

    if (
      typeof gtag != "undefined" &&
      this.sendGAEvents &&
      !this._isDuplicateEventGA(eventGA)
    ) {
      gtag("event", "generate_lead", eventGA);
      this._aCacheEventGA.push(eventGA);
    }
    if (
      typeof fbq != "undefined" &&
      this.sendFBEvents &&
      !this._isDuplicateEventFB(eventFB)
    ) {
      let eventName = category + "-" + action + "-" + label;
      let eventId = oGoogleAnalytics.hashFbCapiEvent(eventName);
      fbq("trackCustom", eventName, eventFB, { eventID: eventId });
      oGoogleAnalytics.sendFbCapiEvent("Event", eventId, eventName, eventFB);
      this._aCacheEventFB.push(eventFB);
    }
  },
  _isDuplicateEventGA: function (event) {
    let result = this._aCacheEventGA.filter(function (item) {
      return (
        item.event_category === event.event_category &&
        item.event_action === event.event_action &&
        item.event_label === event.event_label
      );
    });
    return result.length;
  },
  _isDuplicateEventFB: function (event) {
    let result = this._aCacheEventFB.filter(function (item) {
      return (
        item.category === event.category &&
        item.action === event.action &&
        item.label === event.label
      );
    });
    return result.length;
  },
};

export {
  detectIEEdge,
  convertToArray,
  lazyLoad,
  lazyLoadIE,
  createNotification,
  createSwiper,
  createCarrusel,
  toggleShowOrHidePass,
  validateEmail,
  showPasswordRecovery,
  showSigIn,
  showRecoveryPasswordNotification,
  loadMoreInformation,
  scrollUp,
  changePasswordPanel,
  oTrackingEvents,
};
